export const CP_GET_APPOINTMENT_DETAIL = 'CP_GET_APPOINTMENT_DETAIL';

export const CP_GET_APPOINTMENT_DETAIL_SUCCESS = 'CP_GET_APPOINTMENT_DETAIL_SUCCESS';

export const CP_GET_APPOINTMENT_DETAIL_FAILED = 'CP_GET_APPOINTMENT_DETAIL_FAILED';